// Components
import { Loading } from "components/feedbacks"

// Utils
import { useCoaBsi } from "utils"

export function ProductInventory(params: {
  product_id: string
}) {
  // Hooks
  const { data, isLoading } = useCoaBsi(params.product_id)

  if (isLoading) {
    return (
      <td>
        <Loading loading />
      </td>
    )
  }

  return <td>{data}</td>
}